import React, { useState, useEffect } from 'react'

import UserStore from '../../store/slice/user.slice'

import doUtility from '../utility'

import { useNavigate  } from 'react-router-dom'

import { Loader } from '../utility/componentUtility'

import { Col, Row, Typography, Button, Table, Tooltip } from 'antd'
import { EyeOutlined } from '@ant-design/icons'

const  { Title } = Typography

function IDashboard () {
    const navigate =  useNavigate()

    const getBranches = UserStore((state) => state.getBranches)
    const Branches    = UserStore((state) => state.Branches)
    const [loading, setLoading] = useState(true)

    const [BranchCode, setBranchCode] = useState(null)

    useEffect(() => {
        //if(Branches == null){
            getBranches()
        //}
        setLoading(false)
    }, [getBranches])

    const viewBranchDetails = (branchCode) => {
        setBranchCode(branchCode)        
    }

    useEffect(() => {
        if(BranchCode !== null){
            navigate('/dashboard/branchDetails', {state: {
                SeletedBranch: BranchCode 
            }})
        }
    },[BranchCode, navigate])

    const action = {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
            <div>
                <Tooltip placement="top" title={'View Details'}>
                    <Button type="default" icon={<EyeOutlined />} onClick={ () => viewBranchDetails(record) }>
                    </Button>
                </Tooltip>
            </div>
        )
    }
    
    return(

        <div className='dashboard'>
            <Row className='main-heading'>
                <Col md={24}>
                    <Title level={2}>BRANCHES</Title>
                </Col>
            </Row>

            <Row>
                <Col md={24}>
                    {( () => {
                        if (Branches !== null) {
                            if(loading){
                                return (
                                    <Loader />
                                )
                            }else{
                                const dataBranches = doUtility.RenderTableData(Branches)
                                const column = dataBranches.column.filter(function(item) {
                                    if(item.dataIndex == 'BRANCH_KEY'){
                                        return false
                                    }else{
                                        return true
                                    }
                                });
                                return (
                                    <Table
                                        className='back-white' 
                                        style={{ margin: 'auto', borderRadius: '2px', padding: '10px'}} 
                                        dataSource={dataBranches.datasource} columns={[...column, action]} />
                                )
                            }
                        }
                    }) ()}
                </Col>
            </Row>
        </div>
    )
}

export default IDashboard